export default {
  SMARTCHAT_ALTERNATIVES_UPDATE:                    'SMARTCHAT_ALTERNATIVES_UPDATE',
  SMARTCHAT_ALTERNATIVES_UPDATE_MODAL_ACTION_REF:   'SMARTCHAT_ALTERNATIVES_UPDATE_MODAL_ACTION_REF',
  SMARTCHAT_ALTERNATIVES_UPDATE_ACTION_DETAIL:      'SMARTCHAT_ALTERNATIVES_UPDATE_ACTION_DETAIL',
  SMARTCHAT_ALTERNATIVES_UPDATE_ACTIONS_ERRORS:     'SMARTCHAT_ALTERNATIVES_UPDATE_ACTIONS_ERRORS',
  SMARTCHAT_ALTERNATIVES_UPDATE_MODAL_ERROR:        'SMARTCHAT_ALTERNATIVES_UPDATE_MODAL_ERROR',
  SMARTCHAT_ALTERNATIVES_UPDATE_LOADING:            'SMARTCHAT_ALTERNATIVES_UPDATE_LOADING',
  SMARTCHAT_ALTERNATIVES_UPDATE_ERROR:              'SMARTCHAT_ALTERNATIVES_UPDATE_ERROR'
}
